import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { isScullyRunning } from '@scullyio/ng-lib';

@Component({
  selector: 'placeme-video-block',
  templateUrl: './video-block.component.html',
  styleUrls: ['./video-block.component.scss'],
})
export class VideoBlockComponent implements OnChanges {
  @Input() video: {
    videoID: string;
    platform: 'youtube';
  };
  isScullyRunning = isScullyRunning();
  url: SafeResourceUrl;

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.video && !this.isScullyRunning) {
      switch (this.video.platform) {
        case 'youtube':
          this.url = this.domSanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${this.video.videoID}`);
          break;
      }
    }
  }
}
